import { c as _c } from "react/compiler-runtime";
import type { AdvancedMentoringProductDTO, BasicMentoringProductDTO, CourseProductDTO } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/input.dto/input.dto';
import { ORDER_TYPE } from '@/backend/modules/payment/endpoints/mutations/stripe-checkout/types';
import { SUBSCRIPTION } from '@/common/enums';
import { H1 } from '@/frontend/design-system/_marketing/typography/Heading/H1';
import { H2 } from '@/frontend/design-system/_marketing/typography/Heading/H2';
import { P3 } from '@/frontend/design-system/_marketing/typography/Paragraph';
import { Badge } from '@/frontend/design-system/data-display/Badge';
import { ADVANCED_MENTORING_DISCOUNT_PER_CENT, BASIC_MENTORING_DISCOUNT_PER_CENT, calculatePriceForSubscription } from './prices';
type BuyDataProps = {
  mentoringProduct: BasicMentoringProductDTO | AdvancedMentoringProductDTO | CourseProductDTO;
};
export function BuyData(t0) {
  const $ = _c(24);
  const {
    mentoringProduct
  } = t0;
  const DISCOUNT_PER_CENT = mentoringProduct.order === ORDER_TYPE.ADVANCED_MENTORING ? ADVANCED_MENTORING_DISCOUNT_PER_CENT[mentoringProduct.subscription] : mentoringProduct.order === ORDER_TYPE.BASIC_MENTORING ? BASIC_MENTORING_DISCOUNT_PER_CENT[mentoringProduct.subscription] : 0;
  const pricePerFourWeeks = mentoringProduct.price;
  const subscription = mentoringProduct.subscription;
  let t1;
  if ($[0] !== DISCOUNT_PER_CENT || $[1] !== pricePerFourWeeks || $[2] !== subscription) {
    t1 = calculatePriceForSubscription(pricePerFourWeeks, subscription, DISCOUNT_PER_CENT);
    $[0] = DISCOUNT_PER_CENT;
    $[1] = pricePerFourWeeks;
    $[2] = subscription;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const priceCalculation = t1;
  const {
    originalPrice: originalPriceForPeriod,
    discountedPrice: discountedPriceForPeriod,
    savings: totalSavings
  } = priceCalculation;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <P3 className="text-center text-base text-slate-900">Cena końcowa mentoringu</P3>;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== DISCOUNT_PER_CENT || $[6] !== originalPriceForPeriod) {
    t3 = DISCOUNT_PER_CENT > 0 && <div className="flex flex-row items-center gap-2"><H2 className="relative text-slate-500"><span className="relative">{originalPriceForPeriod} zł<span className="absolute inset-0 flex items-center justify-center"><span className="h-0.5 w-full -rotate-12 transform bg-slate-500" /></span></span></H2><Badge className="bg-blue-100 font-semibold text-algoprimary text-xs">-{DISCOUNT_PER_CENT}%</Badge></div>;
    $[5] = DISCOUNT_PER_CENT;
    $[6] = originalPriceForPeriod;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = DISCOUNT_PER_CENT > 0 ? discountedPriceForPeriod : originalPriceForPeriod;
  let t5;
  if ($[8] !== t4) {
    t5 = <H1 className="text-5xl">{t4} zł</H1>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = subscription === SUBSCRIPTION.PER_4_WEEKS && "/4 tygodnie";
  const t7 = subscription === SUBSCRIPTION.PER_12_WEEKS && "/12 tygodni";
  const t8 = subscription === SUBSCRIPTION.YEARLY && "/rok";
  let t9;
  if ($[10] !== t6 || $[11] !== t7 || $[12] !== t8) {
    t9 = <P3>{t6}{t7}{t8}</P3>;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t5 || $[15] !== t9) {
    t10 = <div className="flex flex-row items-end gap-3">{t5}{t9}</div>;
    $[14] = t5;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== subscription || $[18] !== totalSavings) {
    t11 = subscription !== SUBSCRIPTION.PER_4_WEEKS && totalSavings > 0 && <div className="flex flex-col items-center gap-1"><p className="font-medium text-green-600 text-sm">Oszczędzasz {totalSavings} zł</p></div>;
    $[17] = subscription;
    $[18] = totalSavings;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t3) {
    t12 = <section className="space-y-3">{t2}<div className="flex flex-col items-center gap-2 text-center">{t3}{t10}{t11}</div></section>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t3;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}